require('./hireOpenYoungIntervenerRow.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helper
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');

class HireOpenYoungIntervenerRow extends React.Component {
    render () {
        const {
            id,
            intervenerName,
            onExclude,
            onTypeChange,
            relationship,
            showError,
            showRemoveButton
        } = this.props;
        const RELATIONSHIP_OPTIONS = [
            {
                value: 0, label: formatText('hireOpenYoungInterveners-hireOpenYoungInterveners_father')
            },
            {
                value: 1, label: formatText('hireOpenYoungInterveners-hireOpenYoungInterveners_mother')
            },
            {
                value: 2, label: formatText('hireOpenYoungInterveners-hireOpenYoungInterveners_guardian')
            }
        ];
        const relationshipErrorMsg = formatText('hireOpenYoungInterveners-hireOpenYoungInterveners_dropdownErrorMsg');

        let removeButton;

        if (showRemoveButton){
            removeButton = (
                <div className="col-xs-3 text-right">
                    <OKButton
                        leftIcon="icon-quitar"
                        modifier="ghost"
                        onClick={(evt) => onExclude(id, evt.value)}
                    >
                        <FormattedText value="hireOpenYoungInterveners-hireOpenYoungInterveners_exclude" />
                    </OKButton>
                </div>
            );
        }

        return (
            <div className="hire-open-young-intervener-row row no-gutter">
                <div className="hire-open-young-intervener-row__intervener col-xs-5">
                    <p className="hire-open-young-intervener-row__intervener-name">{intervenerName}</p>
                    <FormattedText
                        className="hire-open-young-intervener-row__sublabel"
                        value="hireOpenYoungInterveners-hireOpenYoungInterveners_legalRepresentative"
                    />
                </div>
                <div className="hire-open-young-intervener-row__relationship col-xs-4">
                    <OKSelect
                        errorMessage={relationshipErrorMsg}
                        errorState={showError}
                        onChange={(evt) => onTypeChange(id, evt.value)}
                        options={RELATIONSHIP_OPTIONS}
                        value={relationship}
                    />
                </div>
                {removeButton}
            </div>
        );
    }
}

HireOpenYoungIntervenerRow.propTypes = {
    id: PropTypes.number.isRequired,
    intervenerName: PropTypes.string.isRequired,
    onExclude: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    relationship: PropTypes.number,
    showError: PropTypes.bool,
    showRemoveButton: PropTypes.bool.isRequired
}

module.exports = HireOpenYoungIntervenerRow;
